import styled from 'styled-components';
import { ProductiveHeading07 } from 'components/styles';

const Row = styled.tr`
  position: relative;
  transform: scale(1);

  td:first-child {
    display: flex;
  }

  .ant-table-selection-column {
    position: static !important;

    .ant-radio-wrapper {
      position: absolute;
      top: 0;
      left: 100px;
      right: 0;
      bottom: 0;
      height: 44px;
      z-index: 3;
      opacity: 0;
    }
  }

  &.ant-table-row-level-0 {
    font-weight: var(--font-weight-bold);
  }

  && .ant-table-cell {
    padding: var(--spacing-03) var(--spacing-05);
    min-height: 40px;
  }

  &.ant-table-row-selected {
    background: var(--blue-10);

    td {
      background: transparent;
    }

    &.private {
      background: var(--private-01);
    }

    &:hover td {
      background: var(--coolest-gray-10);
    }
  }

  &.ant-table-placeholder {
    display: none;
  }
`;

export const BodyRow = styled(Row)`
  cursor: pointer;

  &:hover {
    .more__actions {
      opacity: 1;
    }
  }
`;

export const BodyRowWithBorder = styled(BodyRow)`
  td:first-child {
    border-right: 1px solid var(--border-color);
  }
`;
export const HeaderRow = styled(Row)`
  && .ant-table-cell {
    ${ProductiveHeading07};
    padding: var(--spacing-03) var(--spacing-05);
  }
`;

export const HeaderRowWithBorder = styled(HeaderRow)`
  th:first-child {
    border-right: 1px solid var(--border-color);
  }
`;
